import React, { createContext, useEffect, useState } from "react";
import { GoogleTranslate } from "@react-lib-tech/multi-lang-renderer";

const SiteLanguageContext = createContext(null);

const LANGS = ["en", "te", "hi", "ta", "kn"];

function normalizeLangCode(code) {
    const safeCode = String(code || "en").trim().toLowerCase();
    return LANGS.includes(safeCode) ? safeCode : "en";
}

function getStoredLang() {
    return normalizeLangCode(localStorage.getItem("siteLang"));
}

export function SiteLanguageProvider({ children }) {
    const [lang, setLangState] = useState(() => getStoredLang());

    const setLang = (code) => {
        const nextCode = normalizeLangCode(code);
        localStorage.setItem("siteLang", nextCode);
        setLangState(nextCode);
    };

    useEffect(() => {
        const syncFromStorage = () => {
            const storedLang = getStoredLang();
            setLangState((current) => (current !== storedLang ? storedLang : current));
        };

        const onStorage = (e) => {
            if (e.key === "siteLang") syncFromStorage();
        };

        window.addEventListener("storage", onStorage);
        window.addEventListener("focus", syncFromStorage);
        return () => {
            window.removeEventListener("storage", onStorage);
            window.removeEventListener("focus", syncFromStorage);
        };
    }, []);

    return (
        <SiteLanguageContext.Provider value={{ lang, setLang }}>
            <GoogleTranslate
                defaultLang={lang}
                SkipTranslationTags={["button", "select", "input", "textarea", "script", "style", "code", "pre", "noscript", "iframe", "object"]}
                SkipTranslationClassName={["notranslate", "goog-te-combo", "goog-te-banner-frame", "goog-te-balloon-frame"]}
            >
                {children}
            </GoogleTranslate>
        </SiteLanguageContext.Provider>
    );
}

export default SiteLanguageContext;
